export const DIVISION_CONTACTS = {
  projects: { phone: "+919600557557", whatsapp: "919600557557" },
  physio: { phone: "+917708431557", whatsapp: "917708431557" },
  investment: { phone: "+919894365298", whatsapp: "919894365298" },
};

export const DEFAULT_DIVISION_CONTACT = DIVISION_CONTACTS.projects;

export const CONTACT_BY_ROUTE = {
  "/physio": DIVISION_CONTACTS.physio,
  "/physio-life": DIVISION_CONTACTS.physio,
  "/investment": DIVISION_CONTACTS.investment,
  "/investment-planner": DIVISION_CONTACTS.investment,
};

const SERVICE_CONTACT_RULES = [
  {
    contact: DIVISION_CONTACTS.projects,
    exact: ["M/s Veniinfra Projects Pvt Ltd", "M/s Veni In Projects"],
    keywords: [
      "construction",
      "project",
      "approval",
      "consultancy",
      "drawing",
      "cmda",
      "dtcp",
      "rera",
      "valuation",
      "real estate",
      "building",
      "civil",
      "infra",
    ],
  },
  {
    contact: DIVISION_CONTACTS.physio,
    exact: ["M/s Veni In PhysioLife"],
    keywords: ["physio", "treatment", "clinic", "therapy", "rehab", "hydrotherapy", "ift", "ultrasound", "tens", "traction", "wax", "exercise"],
  },
  {
    contact: DIVISION_CONTACTS.investment,
    exact: ["M/s Veni Investment Planner"],
    keywords: ["investment", "insurance", "lic", "loan", "banking", "financial", "wealth", "vehicle insurance", "health insurance"],
  },
];

export function getContactForRoute(pathname) {
  return CONTACT_BY_ROUTE[pathname] || DEFAULT_DIVISION_CONTACT;
}

export function getContactForService(service = "") {
  const normalizedService = service.trim();
  const lowerService = normalizedService.toLowerCase();

  const exactMatch = SERVICE_CONTACT_RULES.find((rule) => rule.exact.includes(normalizedService));
  if (exactMatch) return exactMatch.contact;

  const keywordMatch = SERVICE_CONTACT_RULES.find((rule) =>
    rule.keywords.some((keyword) => lowerService.includes(keyword))
  );

  return keywordMatch?.contact || DEFAULT_DIVISION_CONTACT;
}
